import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'block',
    padding: '32px',
    width: '100%',
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  heading: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '133.4%',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  btn: {
    padding: '16px 18.5px',
    minWidth: '180px',
    borderRadius: '4px',
  },
  table: {
    margin: '32px 0',
    backgroundColor: 'white',
    display: 'grid',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
  },
  rowNewUser: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  rowHeading: {
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
    lineHeight: '26px',
    lineSpacing: '0.46px',
    textTransform: 'uppercase',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '15px 16px',
    border: '1px solid #E0E0E0',
  },
  rowTitle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '143%',
    lineSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '15px 16px',
    border: '1px solid #E0E0E0',
    textTransform: 'capitalize',
  },
  rowElement: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '143%',
    lineSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '15px 16px',
    border: '1px solid #E0E0E0',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
  rowElementIcons: {
    padding: '3px 4px',
    border: '1px solid #E0E0E0',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  toolbarIcon: {},
  editIcon: {
    color: 'black',
  },
  acceptIcon: {
    color: '#64C968',
  },
  rejectIcon: {
    color: '#FF505F',
  },
}));
